<template>
  <div class="container top-level-div">
    <div class="content-block">
      <h1 class="dashboard-heading" ref="pageTitle">Our Team</h1>
      <hr>
      <!-- <img src="../../assets/img/general/Group pic_compressed.jpg" class="mb-3" alt="Our Team"> -->
      <div v-for="teammember in team" :key="teammember.id">
        <!-- {{ teammember }} -->
        <div class="row">
          <div class="col-lg-4" style="max-width: 175px;">
            <div v-if="teammember.profile_pic != 'https://enginehireio-static-and-media.s3.amazonaws.com/media/img/default_avatar.jpg'">
              <!-- {{ user.profile_pic }} -->
              <!-- https://stackoverflow.com/questions/37645243/static-image-src-in-vue-js-template -->
              <img :src="teammember.profile_pic" style="max-height: 150px; max-width: 150px;">
            </div>
          </div>
          <div class="col-lg-8 my-auto">
            <h2 class="mt-2">{{ teammember.first_name }} {{ teammember.last_name }}</h2>
            <h4>{{ teammember.title }}</h4>
            <div class="mt-2">
              <a v-if="teammember.website" :href="teammember.website" target="_blank">
                <img src="../../assets/img/social/website_squircle_charcoal.svg" alt="website" class='social-icon'>
              </a>
              <!-- <a v-if="teammember.youtube" :href="teammember.youtube" target="_blank">
                <img src="../../assets/img/social/youtube_squircle_charcoal.svg" alt="youtube" class='social-icon'>
              </a> -->
              <a v-if="teammember.facebook" :href="teammember.facebook" target="_blank">
                <img src="../../assets/img/social/facebook_squircle_charcoal.svg" alt="facebook" class='social-icon'>
              </a>
              <a v-if="teammember.instagram" :href="teammember.instagram" target="_blank">
                <img src="../../assets/img/social/instagram_squircle_charcoal.svg" alt="instagram" class='social-icon'>
              </a>
              <a v-if="teammember.twitter" :href="teammember.twitter" target="_blank">
                <img src="../../assets/img/social/twitter_squircle_charcoal.svg" alt="twitter" class='social-icon'>
              </a>
              <a v-if="teammember.linkedin" :href="teammember.linkedin" target="_blank">
                <img src="../../assets/img/social/linkedin_squircle_charcoal.svg" alt="linkedin" class='social-icon'>
              </a>
            </div>
          </div>
        </div>
        <pre class="mt-3" v-html="teammember.about_us"></pre>

        <!-- <div v-if="teammember.profile_pic != 'https://enginehireio-static-and-media.s3.amazonaws.com/media/profile_pics/default_avatar.jpg'">
          <img :src="teammember.profile_pic" style="max-height: 150px;">
        </div>
        {{ teammember.first_name }} {{ teammember.last_name }} -->
        <button v-if="$store.getters.isAgent == 'true'" class="mylisting-button dark-button mt-3" style="display: block;" @click="showEditModal(teammember)">Edit</button>

        <!-- <button class="mylisting-button dark-button" @click="setPresentEmployer(teammember)">Set Present Employer</button> -->
        <hr>
      </div>
    </div>

    <modal name="edit-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <!-- <button v-if="!blog.published" class="mylisting-button dark-button mb-2" @click="publish()">Publish</button> -->
        <!-- <button v-else class="mylisting-button dark-button mb-2" @click="unpublish()">Unpublish</button> -->

        <!-- <img :src="blog.hero_image" alt="" width="100%">
        <h1 class="mt-3">{{ blog.title }}</h1>
        <p class="mt-3">{{ new Date(blog.created_date).toDateString() }}</p>
        <hr>
        <pre v-html="blog.content"></pre> -->
        <!-- <app-blog-post :id="blog.id"></app-blog-post> -->

        <label>Profile Picture</label>
        <div class="mb-1" v-if="teammember.profile_pic != 'https://enginehireio-static-and-media.s3.amazonaws.com/media/img/default_avatar.jpg'">
          <img :src="teammember.profile_pic" style="max-height: 150px;">
        </div>
        <input type="file" class="form-control-file" id="profile_pic" ref="profile_pic" v-on:change="handleFileUpload()"/>

        <div class="profile">
          <label>Order</label>
          <input type="text" class="form-control" placeholder="" v-model="order">
          <label>Title</label>
          <input type="text" class="form-control" placeholder="" v-model="title">
          <label>Website</label>
          <input type="text" class="form-control" placeholder="" v-model="website">
          <!-- <label>Video</label> -->
          <!-- <input type="text" class="form-control" placeholder="Do you have a YouTube video highlighting your organization?" v-model="video"> -->
          <!-- <label>YouTube Channel</label> -->
          <!-- <input type="text" class="form-control" placeholder="youtube.com/channel/..." v-model="youtube"> -->
          <label>Facebook</label>
          <input type="text" class="form-control" placeholder="" v-model="facebook">
          <label>Instagram</label>
          <input type="text" class="form-control" placeholder="" v-model="instagram">
          <label>Twitter</label>
          <input type="text" class="form-control" placeholder="" v-model="twitter">
          <label>LinkedIn</label>
          <input type="text" class="form-control" placeholder="" v-model="linkedin">
        </div>

        <label class="mt-3">Description</label>
        <!-- <textarea class="form-control" rows="8" v-model="summary"></textarea> -->
        <div class="editor">
          <editor-menu-bar :editor="summaryEditor" v-slot="{ commands, isActive }" class="mb-1">
            <div class="menubar">
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bold() }" @click.prevent="commands.bold">
                <strong>B</strong>
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.italic() }" @click.prevent="commands.italic">
                <i>Italics</i>
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.underline() }" @click.prevent="commands.underline">
                <u>U</u>
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="showImagePrompt(commands.image)">
                Image
              </button> -->
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click.prevent="commands.heading({ level: 2 })">
                H1
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 4 }) }" @click.prevent="commands.heading({ level: 3 })">
                H2
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 5 }) }" @click.prevent="commands.heading({ level: 4 })">
                H3
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click.prevent="commands.bullet_list">
                List
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click.prevent="commands.ordered_list">
                1. 2. 3...
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote">
                ""
              </button> -->
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.horizontal_rule() }" @click.prevent="commands.horizontal_rule">
                ---
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.undo() }" @click.prevent="commands.undo">
                Undo
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.redo() }" @click.prevent="commands.redo">
                Redo
              </button> -->
            </div>
          </editor-menu-bar>
          <editor-content class="editor__content" :editor="summaryEditor" />
        </div>

        <hr>
        <button class="mylisting-button dark-button" @click="updateTeamMember()">Save</button>
      </div>
    </modal>
  </div>
</template>

<script>
  import axios from 'axios'

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
  // Import the editor
  import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
  // import Icon from 'Components/Icon'
  import {
    Blockquote,
    CodeBlock,
    HardBreak,
    Heading,
    HorizontalRule,
    OrderedList,
    BulletList,
    ListItem,
    TodoItem,
    TodoList,
    Bold,
    Code,
    Italic,
    Link,
    Strike,
    Underline,
    History,
    Image, // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
  } from 'tiptap-extensions'

  export default {
    data() {
      return {
        team: [],
        teammember: {},

        profilePic: '',
        summary: '',
        summaryEditor: null,

        order: null,
        title: '',
        website: '',
        // video: '',
        // videoId: '',
        twitter: '',
        facebook: '',
        linkedin: '',
        instagram: '',
        youtube: '',
      }
    },
    components: {
      EditorContent,
      EditorMenuBar,
    },
    mounted() {
      document.title = this.$refs.pageTitle.innerHTML

      this.summaryEditor = new Editor({
        content: this.summary,
        autoFocus: true,
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3, 4, 5] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Image(), // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
        ],
        onUpdate: ({ getJSON, getHTML }) => {
          // this.json = getJSON()
          // this.html = getHTML()
          this.summary = getHTML()
        },
      })
    },
    beforeDestroy() {
      this.summaryEditor.destroy()
    },
    created() {
      // Scroll the window to the top on load, since most people will get here via footer
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

      this.getTeam()
    },
    methods: {
      getTeam() {
        // axios.get('/api/people/?status=team&agency='+this.$store.getters.agencyID.toString())
        axios.get('/api/publicusers/?status=team&agency='+this.$store.getters.agencyID.toString())
        // axios.get('/api/publicusers/?present_employer=ThriveHire&agency='+this.$store.getters.agencyID.toString())
          .then(res => {
            this.team = res.data
            // this.team = this.team.sort((a, b) => (a.created_date > b.created_date) ? 1 : -1)
            this.team = this.team.sort((a, b) => (a.order > b.order) ? 1 : -1)
          })
      },
      showEditModal(teammember) {
        this.teammember = teammember

        this.summaryEditor.setContent(this.teammember.about_us)
        this.summary = this.teammember.about_us
        this.order = this.teammember.order
        this.title = this.teammember.title
        this.website = this.teammember.website
        this.facebook = this.teammember.facebook
        this.twitter = this.teammember.twitter
        this.instagram = this.teammember.instagram
        this.youtube = this.teammember.youtube
        this.linkedin = this.teammember.linkedin

        this.$modal.show('edit-modal')
      },
      hideEditModal() {
        this.$modal.hide('edit-modal')
      },
      // https://serversideup.net/uploading-files-vuejs-axios/
      handleFileUpload() {
        this.profilePic = this.$refs.profile_pic.files[0];
      },
      updateTeamMember() {
        axios.patch('/api/people/'+this.teammember.id.toString()+'/', {
          about_us: this.summary,
          order: this.order,
          title: this.title,
          website: this.website,
          // video: this.video,
          facebook: this.facebook,
          twitter: this.twitter,
          instagram: this.instagram,
          youtube: this.youtube,
          linkedin: this.linkedin,
        })
          .then(res => {
            let formData = new FormData();
            if (this.profilePic) {
              formData.append('profile_pic', this.profilePic);
            }

            axios.patch('/api/people/'.concat(this.teammember.id.toString()).concat('/'),
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            )
              .then(res => {
                this.getTeam()

                // https://www.npmjs.com/package/vue-loading-overlay
                let loader = this.$loading.show({
                  // Optional parameters
                  container: this.fullPage ? null : this.$refs.formContainer,
                  // container: this.$refs.formContainer,
                  // canCancel: true,
                  canCancel: false,
                  // onCancel: this.onCancel,
                });
                // simulate AJAX
                setTimeout(() => {
                  loader.hide()
                },2000)

                this.hideEditModal()
              })
          })
      },
      setPresentEmployer(teammember) {
        axios.patch('/api/people/'+teammember.id.toString()+'/', {
          present_employer: 'ThriveHire'
        })
          .then(res => {
            this.getTeam()
          })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/general/Team.vue